import SectionMessage from '@atlaskit/section-message';
import Image from '@atlaskit/image';
import tileAnatomyLight from "../../../../../../packages/design-system/tile/constellation/index/images/tile-anatomy-light.png";
import tileAnatomyDark from "../../../../../../packages/design-system/tile/constellation/index/images/tile-anatomy-dark.png";
import tileReferenceDo from "../../../../../../packages/design-system/tile/constellation/index/images/do-donts/tile-reference-do.png";
import tileReferenceDont from "../../../../../../packages/design-system/tile/constellation/index/images/do-donts/tile-reference-dont.png";
import tileVariantDo from "../../../../../../packages/design-system/tile/constellation/index/images/do-donts/tile-variant-do.png";
import tileVariantDont from "../../../../../../packages/design-system/tile/constellation/index/images/do-donts/tile-variant-dont.png";
import * as React from 'react';
export default {
  SectionMessage,
  Image,
  tileAnatomyLight,
  tileAnatomyDark,
  tileReferenceDo,
  tileReferenceDont,
  tileVariantDo,
  tileVariantDont,
  React
};